import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import Tournaments from '@/pages/Tournaments';
import Streams from '@/pages/Streams';
import About from '@/pages/About';
import Collaborations from '@/pages/Collaborations';
import Legal from '@/pages/Legal';
import Leaderboard from '@/pages/Leaderboard';
import Press from '@/pages/Press';
import Payouts from '@/pages/Payouts';
import Admob from '@/pages/Admob';

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (!el) return;
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
        else el.scrollIntoView({ behavior: 'smooth' });
      }, 250);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <div className="noise-overlay" aria-hidden="true" />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tournaments" element={<Tournaments />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/streams" element={<Streams />} />
          <Route path="/about" element={<About />} />
          <Route path="/collaborations" element={<Collaborations />} />
          <Route path="/privacy-policy" element={<Legal slug="privacy" title="Privacy Policy" />} />
          <Route path="/terms" element={<Legal slug="terms" title="Terms & Conditions" />} />
          <Route path="/refund-policy" element={<Legal slug="refund" title="Refund Policy" />} />
          <Route path="/community-guidelines" element={<Legal slug="community" title="Community Guidelines" />} />
          <Route path="/admob" element={<Admob />} />
          <Route path="/press" element={<Press />} />
          <Route path="/payouts" element={<Payouts />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: { background: '#1a1f2e', border: '1px solid rgba(255,255,255,0.08)', color: '#fff' },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
